// ??? web component simple-accordion
class SimpleAccordion extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    // singleMode: ??????????
    this.singleMode = this.hasAttribute("data-single-mode");
    this.isFooter = this.hasAttribute("data-footer");
    this.items = this.querySelectorAll("[data-accordion-item]");
    this.expandFirst = this.hasAttribute("data-expand-first");

    this.items.forEach((item, index) => {
      const content = item.querySelector("[data-accordion-content]");
      const button = item.querySelector("button");
      if (!content || !button) return;

      if(this.isFooter && window.matchMedia("(min-width: 750px)").matches){
        this.expandItem(item, content, index);
        
      }else{
        if (index === 0 && this.expandFirst) {
          this.expandItem(item, content, index);
        }
        button.addEventListener("click", () => {
          if (this.singleMode) {
            this.items.forEach((_item) => {
              const _content = _item.querySelector("[data-accordion-content]");
              this.collapseItem(_item, _content);
            });
          }
          if (content.style.maxHeight) {
            if (!this.singleMode) {
            }
              this.collapseItem(item, content);
          } else {
            this.expandItem(item, content, index);
          }
        });
     }
    });
  }

  expandItem(item, content, index) {
    item.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
    this.dispatchEvent(
      new CustomEvent(
        "simple-accordion:expand",
        {
          detail: {
            index,
          },
        },
        {
          bubbles: true,
        }
      )
    );
  }
  collapseItem(item, content) {
    item.classList.remove("active");
    content.style.maxHeight = null;
  }
}
if (!customElements.get("simple-accordion")) {
  customElements.define("simple-accordion", SimpleAccordion);
}

(function () {
  var currentScript = document.currentScript;
  var assetBase = currentScript && currentScript.src
    ? currentScript.src.replace(/assets\/[^/?#]+(?:[?#].*)?$/, "assets/")
    : "";

  function loadSwiperCss() {
    if (window.__loadSwiperCss) {
      window.__loadSwiperCss();
      return;
    }
    if (!window.matchMedia("(max-width: 768px)").matches || !assetBase || window.__swiperCssLoaded) return;
    window.__swiperCssLoaded = true;
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = assetBase + "swiper-bundle.min.css";
    document.head.appendChild(link);
  }

  function loadSwiperBundle(callback) {
    if (window.Swiper) {
      callback();
      return;
    }
    loadSwiperCss();
    if (window.__loadSwiperBundle) {
      window.__loadSwiperBundle();
    } else if (!window.__hysProductsSwiperFallbackLoading && assetBase) {
      window.__hysProductsSwiperFallbackLoading = true;
      var script = document.createElement("script");
      script.src = assetBase + "swiper-bundle.min.js";
      script.async = true;
      document.head.appendChild(script);
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (window.Swiper) {
        clearInterval(timer);
        callback();
      } else if (attempts > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function initStaticProductSwipers() {
    if (!window.Swiper) return;
    document
      .querySelectorAll("[data-hys-products-root] product-swiper[data-static-grid]")
      .forEach(function (productSwiper) {
        if (productSwiper.swiper) return;
        var swiperEl = productSwiper.querySelector(".swiper");
        if (!swiperEl || swiperEl.classList.contains("swiper-initialized")) return;
        delete productSwiper.dataset.staticGrid;
        productSwiper.swiper = new Swiper(swiperEl, {
          slidesPerView: 1.5,
          spaceBetween: 10,
          navigation: {
            nextEl: productSwiper.querySelector(".swiper-button-next"),
            prevEl: productSwiper.querySelector(".swiper-button-prev"),
          },
          breakpoints: {
            750: {
              spaceBetween: 20,
              slidesPerView: 3,
            },
            990: {
              slidesPerView: 4,
            },
          },
        });
      });
  }

  function initWhenReady() {
    loadSwiperBundle(initStaticProductSwipers);
  }

  function scheduleViewportInit() {
    var roots = document.querySelectorAll("[data-hys-products-root]");
    if (!roots.length) return;
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          obs.disconnect();
          initWhenReady();
        },
        { rootMargin: "900px 0px" }
      );
      roots.forEach(function (root) { observer.observe(root); });
    } else if ("requestIdleCallback" in window) {
      requestIdleCallback(initWhenReady, { timeout: 5000 });
    } else {
      setTimeout(initWhenReady, 1200);
    }
  }

  scheduleViewportInit();
  if (!window.__bfIsPerfAudit && document.querySelector("[data-hys-products-root]")) {
    setTimeout(initWhenReady, 300);
  }
  document.addEventListener("pointerdown", initWhenReady, { passive: true, once: true });
  document.addEventListener("touchstart", initWhenReady, { passive: true, once: true });
  window.addEventListener("load", function () {
    setTimeout(initWhenReady, 1000);
  });
})();

